/* ++++++++++ --------------- IMPORT / EXPORT --------------- ++++++++++ */
import createHistory from 'history/createBrowserHistory';
export const history = createHistory();



// add listener to history so that when we move from one page to another we scroll to the top (for UX)
history.listen((location, action) => {
	// scrolling the app div because of fancy css stuff happening for modals and otherwise (else we would just scroll the document)
    window.scrollTo(0, 0)
});